import { LIST_ROWS_PER_PAGE } from '../constants';
import { formatDate, MOMENT_FORMATS } from './dateFormat';
import { formatPartnerPlanAmount } from './partnerSubscriptionPlans';

export const PARTNER_PLAN_PAYMENTS_PAGE_SIZE = LIST_ROWS_PER_PAGE;

export const normalizePartnerSubscriptionPayment = (payment = {}) => {
  const amount = Number(payment.amount);
  const paidAt = payment.paidAt ?? payment.paid_at ?? null;
  const createdAt = payment.createdAt ?? payment.created_at ?? null;
  const invoiceDate = payment.invoiceDate ?? payment.invoice_date ?? null;
  const billingPeriodStart = payment.billingPeriodStart ?? payment.billing_period_start ?? null;
  const billingPeriodEnd = payment.billingPeriodEnd ?? payment.billing_period_end ?? null;
  const invoiceUrl = String(payment.invoiceUrl ?? payment.invoice_url ?? '').trim() || null;
  const invoiceNumber =
    String(payment.invoiceNumber ?? payment.invoice_number ?? '').trim() || null;
  const currency =
    String(payment.currency ?? 'AED')
      .trim()
      .toUpperCase() || 'AED';

  return {
    paymentId: payment.paymentId ?? payment.payment_id ?? payment.id ?? null,
    status:
      String(payment.status ?? '')
        .trim()
        .toLowerCase() || null,
    amount: Number.isFinite(amount) ? amount : 0,
    amountLabel: `${formatPartnerPlanAmount(amount)} ${currency}`,
    currency,
    paidAt,
    paidAtLabel: formatDate(paidAt, MOMENT_FORMATS.DATETIME) || null,
    createdAt,
    invoiceNumber,
    invoiceUrl,
    invoiceDate,
    invoiceDateLabel: formatDate(invoiceDate, MOMENT_FORMATS.DATE) || null,
    billingPeriodStart,
    billingPeriodEnd,
    billingPeriodLabel: formatPartnerPaymentBillingPeriod(billingPeriodStart, billingPeriodEnd),
    planName:
      String(payment.planName ?? payment.plan_name ?? 'Partner Portal').trim() || 'Partner Portal',
    ziinaPaymentIntentId: payment.ziinaPaymentIntentId ?? payment.ziina_payment_intent_id ?? null,
    userId: payment.userId ?? payment.user_id ?? null,
  };
};

export const formatPartnerPaymentBillingPeriod = (start, end) => {
  const startLabel = formatDate(start, MOMENT_FORMATS.DATE);
  const endLabel = formatDate(end, MOMENT_FORMATS.DATE);
  if (startLabel && endLabel) return `${startLabel} – ${endLabel}`;
  return startLabel || endLabel || null;
};

export const normalizePartnerPlanPaymentsResponse = (payload = {}, params = {}) => {
  const root = payload?.data ?? payload ?? {};
  const payments = (root.payments ?? []).filter(Boolean).map(normalizePartnerSubscriptionPayment);

  const limit = Number(root.limit ?? params.limit ?? PARTNER_PLAN_PAYMENTS_PAGE_SIZE);
  const page = Number(root.page ?? params.page ?? 1);
  const total = Number(root.total ?? payments.length);
  const totalPages = Number(root.totalPages ?? Math.max(1, Math.ceil(total / Math.max(limit, 1))));

  return {
    payments,
    limit: Number.isFinite(limit) && limit > 0 ? limit : PARTNER_PLAN_PAYMENTS_PAGE_SIZE,
    page: Number.isFinite(page) && page > 0 ? page : 1,
    total: Number.isFinite(total) && total >= 0 ? total : payments.length,
    totalPages: Number.isFinite(totalPages) && totalPages > 0 ? totalPages : 1,
  };
};
